import { Box, Stack, SvgIcon, Typography } from "@mui/material";
import { forwardRef, isValidElement, useEffect, useRef, useState } from "react";
import { selectContent } from "../lib/utils";
import { StyledContentEditableContainer, StyledContentEditableContent } from "./CustomContentEditable.styles";

const CustomContentEditable = forwardRef((props, ref) => {
  const { value, startIcon, label, startLabel, isFocused, allowFocus = true, endIcon, slotProps } = props;
  const { container: containerProps, contentEditable: contentEditableProps } = slotProps;
  const [editableFocused, setEditableFocused] = useState(isFocused);
  const editableRef = useRef();
  const lastPressedKey = useRef();
  // prettier-ignore
  const allowedKeys = useRef(props.isNumerical ? [
    "0", "1", "2", "3", "4", "5", "6", "7", "8", "9",
    "Backspace", "Delete", "End", "Home", "Tab", "Control", "a", "Enter",
    "ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown",
  ] : []);
  const onClickContainer = event => allowFocus && selectContent(editableRef.current.el.current);
  const onFocusEditable = event => {
    if (!allowFocus) {
      return editableRef.current.el.current.blur();
    }
    setEditableFocused(true);
    selectContent(editableRef.current.el.current);
  };

  const onBlurEditable = event => {
    setEditableFocused(false);
    if (contentEditableProps?.onBlur) {
      contentEditableProps?.onBlur(event);
    }
  };

  const onChangeEditable = event => {
    if(contentEditableProps?.onChange) {
      contentEditableProps?.onChange(event);
    }
  };

  const onKeyDownEditable = event => {
    if (false === allowedKeys.current.includes(event.key)
    // allow selection of entire field with Ctrl+a
    || event.key === "a" && lastPressedKey.current !== "Control") {
      event.preventDefault();
      console.log(event);
    }

    if (contentEditableProps?.onKeyDown) {
      contentEditableProps?.onKeyDown(event);
    }

    lastPressedKey.current = event.key;
  };

  useEffect(() => {
    // per selezionare manualmente l'elemento
    // ho bisogno di uscire dal ciclo corrente degli eventi
    // altrimenti il focus viene passato direttamente alla root html
    // bypassando il mio focus()
    setTimeout(() => {
      if (isFocused) {
        selectContent(editableRef.current.el.current);
        editableRef.current.el.current.focus();
      }
    });
  }, []);

  return (
    <Box {...containerProps} onClick={onClickContainer} ref={ref}>
      <Stack direction={'row'} sx={{ placeItems: 'center', }}>
        {startLabel && startLabel}
        <Stack>
          {label && <Typography lineHeight={1}>{label}</Typography>}
          <StyledContentEditableContainer direction={'row'} className={editableFocused && 'is-focused'}>
            {startIcon && (isValidElement(startIcon) ? startIcon : <SvgIcon start component={startIcon} inheritViewBox />)}
            <StyledContentEditableContent 
              ref={editableRef}
              html={`${value}`} 
              {...contentEditableProps}
              isFocused={editableFocused}
              onFocus={onFocusEditable}
              onBlur={onBlurEditable}
              onChange={onChangeEditable}
              onKeyDown={onKeyDownEditable}
            />
            {endIcon && (isValidElement(endIcon) ? endIcon : <SvgIcon start component={endIcon} inheritViewBox />)}
          </StyledContentEditableContainer>
        </Stack>
      </Stack>
    </Box>
  );
});

export default CustomContentEditable;
